import { createStructuredSelector } from "reselect";
import {
    PUBLICATION_DOCUMENT_LIST,
    PUBLICATION_DOCUMENT_LIST_SUCCESS,
    PUBLICATION_DOCUMENT_LIST_ERROR,
    PUBLICATION_DOCUMENT_PAGE_SET,
    PUBLICATION_DOCUMENT_HEADER,
    PUBLICATION_DOCUMENT_SEARCH_SET,
    PUBLICATION_DOCUMENT_SEARCH_CHANGE
} from "../actions";

export const NAME = 'publicationDocument';

export const PublicationDocumentList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: PUBLICATION_DOCUMENT_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const PublicationDocumentListSuccess = (data) => ({
    type: PUBLICATION_DOCUMENT_LIST_SUCCESS,
    payload: data
});

export const PublicationDocumentListError = (error) => ({
    type: PUBLICATION_DOCUMENT_LIST_ERROR,
    payload: error
});

export const PublicationDocumentPageSet = (data) => ({
    type: PUBLICATION_DOCUMENT_PAGE_SET,
    payload: data
});

export const PublicationDocumentHeader = (data) => ({
    type: PUBLICATION_DOCUMENT_HEADER,
    payload: data
})

export const PublicationDocumentSearchSet = (data) => ({
    type: PUBLICATION_DOCUMENT_SEARCH_SET,
    payload: data
});

export const PublicationDocumentSearchChangeSet = (data) => ({
    type: PUBLICATION_DOCUMENT_SEARCH_CHANGE,
    payload: data
});

const publicationDocument = (state) => state[NAME];

export const PublicationDocumentSelector = createStructuredSelector({
    publicationDocument
})
